export default {
  name: "BolideAssistantHeader",

  props: {
    title: {
      type: String,
      default: "AI Dashboard Assistant",
    },
    is_fullscreen: Boolean,
    is_history_open: Boolean,
    show_fullscreen: {
      type: Boolean,
      default: true,
    },
  },

  emits: [
    "toggle-history",
    "new-conversation",
    "toggle-fullscreen",
    "close",
  ],
};
